import React, { useEffect } from "react";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <div id="about" className="cover">
          <div className="about_body">
            <div className="heading">
              <div data-aos="fade-up" className="head1">ABOUT ME</div>
              <div data-aos="fade-up" data-aos-delay="150" className="head2">LET ME INTRODUCE MYSELF</div>
            </div>
            <div className="describe_body">
              <div data-aos="fade-right" data-aos-delay="350" className="profile_pic" />
              <div data-aos="fade-left" data-aos-delay="350" className="describe_para">
                <p>
                Meet Rohan, a front-end developer and content creator. I regularly
                create content based on Development, React, Javascript and many more.
                Connect with me!
                </p>
              </div>
            </div>
          </div>
      </div>
    </>
  );
};

export default About;
